import React from 'react';
import {useColorScheme} from 'shared/lib/hooks';
import {EmptyContainer} from 'shared/ui/EmptyContainer';

export const EmptySynchronize = ({size = 400}: {size?: number}) => {
  const colorScheme = useColorScheme();
  return (
    <EmptyContainer size={size}>
      {colorScheme === 'light' ? (
        <svg width={size} height={size} viewBox="0 0 400 400" fill="none">
          <path
            d="M201.682 356.52C276.779 356.52 337.561 295.461 337.561 220.125C337.561 144.79 276.779 83.9503 201.682 83.9503C126.586 83.9503 65.8037 145.009 65.8037 220.345C65.8037 295.9 126.806 356.52 201.682 356.52Z"
            fill="#EAEEF9"
          />
          <path
            d="M266.586 356.222C245.885 356.881 220.999 356.222 203.381 356.003C185.983 356.662 160.878 356.881 140.177 356.222C160.658 344.581 167.925 322.837 168.806 308.561H237.516C239.058 322.618 246.325 344.362 266.586 356.222Z"
            fill="#D5DDEA"
          />
          <g filter="url(#filter0_d_18298_2738)">
            <path
              d="M333.095 126.702V306.145C333.095 310.757 329.571 314.052 325.607 314.052H82.4788C78.2946 314.052 74.9912 310.538 74.9912 306.145V126.702C74.9912 122.528 78.5148 118.795 82.4788 118.795H325.166C329.791 118.795 333.095 122.528 333.095 126.702Z"
              fill="#F1F3F9"
            />
          </g>
          <path
            d="M333.095 126.702V281.106H74.9912V126.702C74.9912 122.528 78.5148 118.795 82.4788 118.795H325.166C329.791 118.795 333.095 122.528 333.095 126.702Z"
            fill="#CBD4E0"
          />
          <path
            d="M333 125.848V281H75V125.848C75 121.622 78.6126 118 82.5263 118H325.173C329.688 118 333 121.622 333 125.848Z"
            fill="#CBD4E0"
          />
          <path
            d="M324.191 128.338H84.9795V271.124H324.492V128.338H324.191Z"
            fill="#F8F9FC"
          />
          <path
            d="M209.768 137.684H197.876V184.441H209.768V137.684Z"
            fill="#D5DDEA"
          />
          <path
            d="M203.601 303.07C207.125 303.07 209.988 300.435 209.988 296.701C209.988 293.187 207.345 290.331 203.601 290.331C200.078 290.331 197.215 292.967 197.215 296.701C197.215 300.435 199.858 303.07 203.601 303.07Z"
            fill="#D6DDE8"
          />
          <path
            d="M25 356.442H372.955"
            stroke="#D6DDE8"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.5068 204.092C54.5719 204.092 58.536 200.138 58.536 195.087C58.536 190.035 54.5719 186.081 49.5068 186.081C44.4416 186.081 40.4775 190.035 40.4775 195.087C40.4775 199.919 44.6618 204.092 49.5068 204.092Z"
            fill="#EAEEF9"
          />
          <path
            d="M40.4798 174.88C43.7831 174.88 46.6461 172.025 46.6461 168.73C46.6461 165.435 43.7831 162.58 40.4798 162.58C37.1764 162.58 34.3135 165.435 34.3135 168.73C34.3135 172.025 37.1764 174.88 40.4798 174.88Z"
            fill="#EAEEF9"
          />
          <path
            d="M298.362 102.839C301.665 102.839 304.528 99.9838 304.528 96.6893C304.528 93.3947 301.665 90.5394 298.362 90.5394C295.058 90.5394 292.195 93.3947 292.195 96.6893C292.195 99.9838 294.838 102.839 298.362 102.839Z"
            fill="#EAEEF9"
          />
          <path
            d="M363.547 226.714C369.934 226.714 374.999 221.663 374.999 215.293C374.999 208.924 369.934 203.872 363.547 203.872C357.161 203.872 352.096 208.924 352.096 215.293C352.096 221.663 357.161 226.714 363.547 226.714Z"
            fill="#EAEEF9"
          />
          <path
            d="M203.584 259.609C228.387 259.609 248.493 239.503 248.493 214.701C248.493 189.898 228.387 169.792 203.584 169.792C178.782 169.792 158.676 189.898 158.676 214.701C158.676 239.503 178.782 259.609 203.584 259.609Z"
            fill="url(#paint0_linear_18298_2738)"
          />
          <path
            d="M155.152 258.704C143.48 247.282 136.873 231.908 136.653 215.655H140.397C142.599 215.655 143.7 213.239 142.379 211.482L134.451 201.378C133.35 200.061 131.368 200.061 130.267 201.378L122.339 211.482C121.017 213.239 122.339 215.655 124.321 215.655H127.624C127.844 234.324 135.552 251.895 148.986 265.073C149.867 265.952 150.968 266.391 152.069 266.391C153.17 266.391 154.271 265.952 155.152 265.073C156.914 263.096 156.914 260.461 155.152 258.704Z"
            fill="#D5DDEA"
          />
          <path
            d="M282.002 213.458H278.478C278.258 194.789 270.77 177.438 257.557 164.26C255.795 162.502 253.152 162.502 251.391 164.26C249.629 166.017 249.629 168.652 251.391 170.409C263.063 181.831 269.449 197.205 269.669 213.458H266.146C263.943 213.458 262.842 215.874 264.164 217.631L272.092 227.735C273.193 229.052 275.175 229.052 276.276 227.735L284.204 217.631C285.305 215.874 284.204 213.458 282.002 213.458Z"
            fill="#D5DDEA"
          />
          <g filter="url(#filter1_d_18298_2738)">
            <path
              d="M285.338 118.128C285.338 134.152 272.379 147.111 256.216 147.111C255.937 147.111 253.568 147.111 236.151 147.111C224.028 147.111 204.66 147.111 173.727 147.111H158.957C139.589 147.529 124.122 132.062 124.122 113.391C124.122 94.5801 139.728 78.9741 159.375 79.9495C176.235 27.2792 253.429 34.6642 259.978 89.1459C274.469 90.9573 285.338 103.219 285.338 118.128Z"
              fill="url(#paint1_linear_18298_2738)"
            />
          </g>
          <path
            d="M256.216 147.111C272.24 147.111 285.338 134.153 285.338 118.129C285.338 102.105 272.24 89.1461 256.216 89.1461C240.192 89.1461 227.094 102.105 227.094 118.129C227.094 134.153 240.192 147.111 256.216 147.111Z"
            fill="url(#paint2_linear_18298_2738)"
          />
          <path
            d="M208.7 147.39C237.265 147.39 260.535 124.259 260.535 95.6949C260.535 67.1303 237.265 44 208.7 44C180.136 44 156.866 67.1303 156.866 95.6949C156.866 124.259 179.997 147.39 208.7 147.39Z"
            fill="url(#paint3_linear_18298_2738)"
          />
          <path
            d="M195.012 96.8312C196.113 95.733 196.113 93.9759 195.012 92.8777C193.911 91.7796 192.59 91.9992 190.828 91.9992C195.893 79.2603 212.41 76.405 220.999 86.7279C224.302 90.2421 229.587 85.6297 226.504 82.1155C217.475 71.573 201.399 70.2552 190.828 79.2603C186.864 82.5548 184.221 86.9475 182.9 91.9992C179.376 91.9992 178.716 91.9992 177.835 92.8777C176.734 93.9759 176.734 95.733 177.835 96.8312C187.965 106.715 185.322 106.715 195.012 96.8312Z"
            fill="#939CAD"
          />
          <path
            d="M238.177 103.201L232.011 96.8312C230.91 95.733 229.148 95.733 228.047 96.8312L221.66 103.201C220.559 104.299 220.559 106.056 221.66 107.154C222.762 108.252 224.083 108.033 225.845 108.033C220.78 120.991 203.822 123.627 195.233 112.645C193.912 110.888 191.71 110.668 189.948 111.986C184.442 116.599 197.436 126.702 208.887 126.702C220.119 126.702 230.469 119.015 233.112 107.813C236.636 107.813 237.296 107.813 238.177 106.934C239.278 106.276 239.278 104.518 238.177 103.201Z"
            fill="#939CAD"
          />
          <path
            d="M229.982 212.048C229.982 209.514 227.649 209.514 225.705 209.124C223.761 208.734 223.566 207.174 222.789 205.419C221.233 202.299 227.066 200.544 223.955 197.619C221.039 194.694 219.289 192.159 216.956 193.914C215.401 195.084 214.234 196.254 212.484 195.474C210.735 194.694 208.985 194.499 208.79 192.549C208.013 187.479 207.818 188.259 201.013 188.259C196.736 188.259 199.652 193.524 196.347 194.694C194.403 195.279 193.237 196.449 191.681 195.279C187.598 192.159 187.987 192.939 183.127 197.814C181.377 199.569 182.738 201.129 184.099 202.884C185.265 204.444 184.293 205.809 183.515 207.564C182.349 210.879 177.1 207.954 177.1 212.243C177.1 214.193 177.1 216.143 177.294 218.093C178.072 220.433 180.016 219.458 182.155 220.238C182.155 220.238 182.349 220.238 182.349 220.433C182.349 220.433 182.349 220.433 182.543 220.433C183.127 220.823 183.321 221.213 183.515 221.798C183.515 221.993 183.904 222.578 183.904 222.773C184.488 224.333 185.071 225.113 184.099 226.478C181.182 230.378 181.571 230.183 186.626 235.058C189.543 237.983 191.292 232.328 194.403 233.888C195.57 234.473 197.514 234.863 197.903 236.228C198.292 237.203 198.097 238.763 198.68 239.738C199.652 241.688 202.569 241.103 205.874 241.103C210.151 241.103 207.235 235.838 210.54 234.668C214.429 233.303 213.651 232.913 216.956 235.253C219.289 237.008 221.233 234.083 223.955 231.548C226.872 228.623 221.233 226.868 222.789 223.748C223.178 223.163 223.372 222.383 223.566 221.798C224.15 220.043 225.899 220.043 227.649 219.848C230.76 219.068 229.982 216.143 229.982 212.048ZM203.541 223.748C198.486 223.748 194.403 219.653 194.403 214.583C194.403 209.514 198.486 205.419 203.541 205.419C208.596 205.419 212.679 209.514 212.679 214.583C212.873 219.653 208.79 223.748 203.541 223.748C203.735 223.748 203.541 223.748 203.541 223.748Z"
            fill="white"
          />
          <defs>
            <filter
              id="filter0_d_18298_2738"
              x="52.9912"
              y="107.795"
              width="302.104"
              height="239.257"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_18298_2738"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_18298_2738"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_18298_2738"
              x="102.122"
              y="33.1259"
              width="205.216"
              height="146.993"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_18298_2738"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_18298_2738"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_18298_2738"
              x1="158.635"
              y1="214.71"
              x2="248.509"
              y2="214.71"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#B0BACC" />
              <stop offset="1" stopColor="#969EAE" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_18298_2738"
              x1="204.73"
              y1="86.6867"
              x2="204.677"
              y2="148.23"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="white" />
              <stop offset="0.9964" stopColor="#ECF0F5" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_18298_2738"
              x1="223.995"
              y1="82.9062"
              x2="249.811"
              y2="111.142"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#BCCBE1" />
              <stop offset="0.9942" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_18298_2738"
              x1="152.012"
              y1="71.9735"
              x2="192.701"
              y2="87.8963"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#E2E8F0" />
              <stop offset="0.9942" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      ) : (
        <svg width={size} height={size} viewBox="0 0 400 400" fill="none">
          <path
            d="M201.683 356.392C276.779 356.392 337.561 295.333 337.561 219.998C337.561 144.662 276.779 83.8225 201.683 83.8225C126.586 83.8225 65.8037 144.882 65.8037 220.217C65.8037 295.772 126.806 356.392 201.683 356.392Z"
            fill="#2A2E37"
          />
          <path
            d="M266.587 356.095C245.886 356.754 221 356.095 203.382 355.875C185.985 356.534 160.879 356.754 140.178 356.095C160.659 344.454 167.926 322.71 168.807 308.434H237.517C239.059 322.491 246.326 344.235 266.587 356.095Z"
            fill="url(#paint0_linear_18298_2735)"
          />
          <path
            d="M333.095 126.574V306.018C333.095 310.63 329.571 313.925 325.607 313.925H82.4789C78.2946 313.925 74.9912 310.411 74.9912 306.018V126.574C74.9912 122.401 78.5148 118.667 82.4789 118.667H325.167C329.792 118.667 333.095 122.401 333.095 126.574Z"
            fill="url(#paint1_linear_18298_2735)"
          />
          <path
            d="M333.095 126.574V280.979H74.9912V126.574C74.9912 122.401 78.5148 118.667 82.4789 118.667H325.167C329.792 118.667 333.095 122.401 333.095 126.574Z"
            fill="#262A31"
          />
          <path
            d="M324.192 128.211H84.9805V270.997H324.493V128.211H324.192Z"
            fill="#474E61"
          />
          <path
            d="M209.769 137.556H197.877V184.314H209.769V137.556Z"
            fill="#262A31"
          />
          <path
            d="M203.601 302.943C207.125 302.943 209.988 300.308 209.988 296.574C209.988 293.06 207.345 290.204 203.601 290.204C200.078 290.204 197.215 292.84 197.215 296.574C197.215 300.308 199.858 302.943 203.601 302.943Z"
            fill="#262A31"
          />
          <path
            d="M25 356.314H372.955"
            stroke="#2B323C"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.5077 203.964C54.5729 203.964 58.537 200.011 58.537 194.959C58.537 189.907 54.5729 185.954 49.5077 185.954C44.4426 185.954 40.4785 189.907 40.4785 194.959C40.4785 199.791 44.6628 203.964 49.5077 203.964Z"
            fill="#2A2E37"
          />
          <path
            d="M40.4788 174.752C43.7822 174.752 46.6451 171.897 46.6451 168.602C46.6451 165.308 43.7822 162.453 40.4788 162.453C37.1754 162.453 34.3125 165.308 34.3125 168.602C34.3125 171.897 37.1754 174.752 40.4788 174.752Z"
            fill="#2A2E37"
          />
          <path
            d="M298.362 102.712C301.665 102.712 304.528 99.8563 304.528 96.5617C304.528 93.2671 301.665 90.4119 298.362 90.4119C295.058 90.4119 292.195 93.2671 292.195 96.5617C292.195 99.8563 294.838 102.712 298.362 102.712Z"
            fill="#2A2E37"
          />
          <path
            d="M363.548 226.587C369.935 226.587 375 221.535 375 215.166C375 208.797 369.935 203.745 363.548 203.745C357.162 203.745 352.097 208.797 352.097 215.166C352.097 221.535 357.162 226.587 363.548 226.587Z"
            fill="#2A2E37"
          />
          <g filter="url(#filter0_d_18298_2735)">
            <path
              d="M203.584 259.482C228.387 259.482 248.493 239.376 248.493 214.573C248.493 189.771 228.387 169.665 203.584 169.665C178.782 169.665 158.676 189.771 158.676 214.573C158.676 239.376 178.782 259.482 203.584 259.482Z"
              fill="url(#paint2_linear_18298_2735)"
            />
          </g>
          <path
            d="M155.153 258.576C143.481 247.155 136.874 231.781 136.654 215.527H140.398C142.6 215.527 143.701 213.111 142.38 211.354L134.452 201.251C133.351 199.933 131.369 199.933 130.268 201.251L122.34 211.354C121.018 213.111 122.339 215.527 124.322 215.527H127.625C127.845 234.197 135.553 251.768 148.987 264.946C149.868 265.824 150.969 266.264 152.07 266.264C153.171 266.264 154.272 265.824 155.153 264.946C156.915 262.969 156.915 260.333 155.153 258.576Z"
            fill="#474E61"
          />
          <path
            d="M282.002 213.331H278.478C278.258 194.662 270.77 177.31 257.557 164.132C255.795 162.375 253.152 162.375 251.391 164.132C249.629 165.889 249.629 168.525 251.391 170.282C263.063 181.703 269.449 197.078 269.669 213.331H266.146C263.944 213.331 262.842 215.747 264.164 217.504L272.092 227.607C273.193 228.925 275.175 228.925 276.276 227.607L284.204 217.504C285.305 215.747 284.204 213.331 282.002 213.331Z"
            fill="#474E61"
          />
          <g filter="url(#filter1_d_18298_2735)">
            <path
              d="M287.057 117.916C287.057 134.11 273.96 147.207 257.625 147.207C257.343 147.207 254.949 147.207 237.347 147.207C225.095 147.207 205.521 147.207 174.259 147.207H159.332C139.758 147.629 124.127 131.998 124.127 113.128C124.127 94.1174 139.899 78.3454 159.755 79.3312C176.794 26.1009 254.809 33.5644 261.427 88.6253C276.073 90.456 287.057 102.848 287.057 117.916Z"
              fill="#5E6882"
            />
          </g>
          <path
            d="M209.606 147.489C238.474 147.489 261.991 124.113 261.991 95.2445C261.991 66.3763 238.474 43 209.606 43C180.738 43 157.221 66.3763 157.221 95.2445C157.221 124.113 180.597 147.489 209.606 147.489Z"
            fill="url(#paint3_linear_18298_2735)"
          />
          <path
            d="M257.627 147.207C273.821 147.207 287.058 134.11 287.058 117.916C287.058 101.722 273.821 88.6252 257.627 88.6252C241.432 88.6252 228.195 101.722 228.195 117.916C228.195 134.11 241.432 147.207 257.627 147.207Z"
            fill="url(#paint4_linear_18298_2735)"
            fillOpacity="0.37"
          />
          <path
            d="M195.015 96.704C196.116 95.6059 196.116 93.8488 195.015 92.7506C193.914 91.6524 192.593 91.872 190.831 91.872C195.896 79.1331 212.413 76.2778 221.002 86.6007C224.305 90.1149 229.59 85.5026 226.507 81.9884C217.478 71.4458 201.402 70.128 190.831 79.1331C186.867 82.4276 184.224 86.8204 182.903 91.872C179.379 91.872 178.718 91.872 177.838 92.7506C176.736 93.8488 176.736 95.6059 177.838 96.704C187.968 106.588 185.325 106.588 195.015 96.704Z"
            fill="#2A2E37"
          />
          <path
            d="M238.176 103.073L232.01 96.7038C230.909 95.6056 229.147 95.6056 228.046 96.7038L221.66 103.073C220.558 104.171 220.558 105.929 221.66 107.027C222.761 108.125 224.082 107.905 225.844 107.905C220.779 120.864 203.821 123.499 195.233 112.518C193.911 110.761 191.709 110.541 189.947 111.859C184.442 116.471 197.435 126.574 208.886 126.574C220.118 126.574 230.469 118.887 233.111 107.686C236.635 107.686 237.295 107.686 238.176 106.807C239.278 106.148 239.278 104.391 238.176 103.073Z"
            fill="#2A2E37"
          />
          <path
            d="M229.982 211.921C229.982 209.387 227.649 209.387 225.705 208.997C223.761 208.607 223.566 207.047 222.789 205.292C221.233 202.172 227.066 200.417 223.955 197.492C221.039 194.567 219.289 192.032 216.956 193.787C215.401 194.957 214.234 196.127 212.484 195.347C210.735 194.567 208.985 194.372 208.79 192.422C208.013 187.352 207.818 188.132 201.013 188.132C196.736 188.132 199.653 193.397 196.347 194.567C194.403 195.152 193.237 196.322 191.681 195.152C187.598 192.032 187.987 192.812 183.127 197.687C181.377 199.442 182.738 201.002 184.099 202.757C185.265 204.317 184.293 205.682 183.516 207.437C182.349 210.751 177.1 207.827 177.1 212.116C177.1 214.03 177.1 215.943 177.283 217.856C177.29 217.929 177.306 218.004 177.331 218.073C178.127 220.261 180.023 219.356 182.111 220.095C182.139 220.106 182.171 220.11 182.2 220.117C182.23 220.124 182.269 220.139 182.299 220.17C182.357 220.228 182.354 220.306 182.437 220.306C182.466 220.306 182.557 220.315 182.581 220.332C183.084 220.678 183.287 221.028 183.463 221.518C183.499 221.619 183.517 221.727 183.555 221.827C183.628 222.014 183.78 222.281 183.858 222.473C183.902 222.583 183.926 222.704 183.969 222.816C184.529 224.264 185.035 225.036 184.099 226.351C181.182 230.251 181.571 230.056 186.626 234.931C189.543 237.856 191.292 232.201 194.403 233.761C195.57 234.346 197.514 234.736 197.903 236.101C198.292 237.076 198.097 238.636 198.68 239.611C199.653 241.561 202.569 240.976 205.874 240.976C210.151 240.976 207.235 235.711 210.54 234.541C214.429 233.176 213.651 232.786 216.956 235.126C219.289 236.881 221.233 233.956 223.955 231.421C226.872 228.496 221.233 226.741 222.789 223.621C223.178 223.036 223.372 222.256 223.566 221.671C224.15 219.916 225.9 219.916 227.649 219.721C230.76 218.941 229.982 216.016 229.982 211.921ZM203.541 223.621C198.486 223.621 194.403 219.526 194.403 214.456C194.403 209.387 198.486 205.292 203.541 205.292C208.596 205.292 212.679 209.387 212.679 214.456C212.873 219.526 208.79 223.621 203.541 223.621C203.735 223.621 203.541 223.621 203.541 223.621Z"
            fill="#474E61"
          />
          <defs>
            <filter
              id="filter0_d_18298_2735"
              x="154.676"
              y="169.665"
              width="97.8174"
              height="97.8171"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_18298_2735"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_18298_2735"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_18298_2735"
              x="111.127"
              y="41.1267"
              width="188.93"
              height="130.088"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="6.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_18298_2735"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_18298_2735"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_18298_2735"
              x1="203.113"
              y1="355.256"
              x2="203.113"
              y2="312.305"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#474755" />
              <stop offset="0.9913" stopColor="#2F3338" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_18298_2735"
              x1="203.492"
              y1="308.898"
              x2="203.492"
              y2="134.394"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#474E61" />
              <stop offset="0.9913" stopColor="#2F3338" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_18298_2735"
              x1="179.279"
              y1="193.242"
              x2="217.917"
              y2="258.656"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#E3EAF7" />
              <stop offset="1" stopColor="#ADB6C8" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_18298_2735"
              x1="169.988"
              y1="64.7029"
              x2="187.53"
              y2="78.2616"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#80889D" />
              <stop offset="0.9942" stopColor="#5E6882" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_18298_2735"
              x1="224.997"
              y1="82.4111"
              x2="251.044"
              y2="110.963"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="white" />
              <stop offset="0.9942" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </EmptyContainer>
  );
};
